import { SiteNavigationMobileController } from "./site-navigation-mobile.controller";

export class SiteNavigationMobileComponent {
  controller: any = SiteNavigationMobileController;
  templateUrl: string = "/html/components/mobile_site_navigation";
}

angular.module("BookingApp").component("siteNavigationMobile", new SiteNavigationMobileComponent());
